import { styled, keyframes } from '@acko-tech/building-blocks.ui.common';

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

const slideUp = keyframes`
    from {
        transform: translateY(20px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
`;

const spin = keyframes`
    to {
        transform: rotate(360deg);
    }
`;

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    animation: ${fadeIn} 0.2s ease-out;
`;

export const Backdrop = styled.div`
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.75);
    cursor: pointer;
`;

export const Modal = styled.div`
    position: relative;
    background: #fff;
    border-radius: 12px;
    width: 90vw;
    max-width: 400px;
    overflow: hidden;
    animation: ${slideUp} 0.25s ease-out;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #eee;
`;

export const Title = styled.span`
    font-size: 16px;
    font-weight: 600;
    color: #040222;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    color: #666;
    line-height: 1;
    transition: background-color 0.15s;

    &:hover {
        background: #f0f0f0;
    }
`;

export const Body = styled.div`
    padding: 20px;
`;

export const Reader = styled.div<{ isVisible: boolean }>`
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
`;

export const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
    gap: 16px;

    p {
        margin: 0;
        font-size: 14px;
        color: #666;
    }
`;

export const Spinner = styled.div`
    width: 36px;
    height: 36px;
    border: 3px solid #e0e0e0;
    border-top-color: #40a7a3;
    border-radius: 50%;
    animation: ${spin} 0.8s linear infinite;
`;

export const StatusContainer = styled.div`
    text-align: center;
    padding: 20px 0;
`;

export const ErrorText = styled.p`
    margin: 0 0 20px;
    font-size: 14px;
    line-height: 1.5;
    color: #333;
`;

export const Actions = styled.div`
    display: flex;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;
`;

const BaseButton = styled.button`
    padding: 10px 24px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.15s;
`;

export const PrimaryButton = styled(BaseButton)`
    background: #40a7a3;
    color: white;
    border: none;

    &:hover {
        background: #358a87;
    }
`;

export const SecondaryButton = styled(BaseButton)`
    background: white;
    color: #333;
    border: 1px solid #ddd;

    &:hover {
        background: #f5f5f5;
        border-color: #ccc;
    }
`;
